import React from 'react'
import { Link } from 'react-router-dom'

const ErrorPage = () => {
    return (
        <div className="container-fluid">
           Page not found. 
           Please <Link to={'/main-dashboard'}>Click here </Link> to go to Dashboard
        </div>
    )
}

export default ErrorPage
